// Multi-tenant: Available tenant information
export interface AvailableTenant {
  tenantId: string;
  tenantName: string;
  roles: string[];
  rolActive: string;
}

// User type enum
export type UserTypeEnum = 'app-user' | 'operator';

export type UserType = {
  id: string;
  email?: string; // Optional: only app-users have email
  name: string;
  surName: string;
  userType: UserTypeEnum; // NUEVO: Type of user
  rolActive: string;
  roles: string[];
  permissions: { [key in AccessZone]?: Permission[] };
  accessZones: string[];
  validated: boolean;

  // Team membership (M2M support)
  teamIDs?: string[]; // ✅ M2M: All team IDs the user belongs to

  // Multi-tenant fields
  activeTenantId?: string;
  availableTenants?: AvailableTenant[];

  // Deprecated: usar activeTenantId en su lugar
  /** @deprecated Use activeTenantId instead */
  tenantId?: string;
};

export interface AuthType {
  user: UserType;
  accessToken: string;
  refreshToken: string;

  // Multi-tenant: información de tenants disponibles (siempre presente desde el backend)
  // Duplicado desde user.availableTenants para conveniencia de acceso directo
  availableTenants: AvailableTenant[];
}

export enum Role {
  SuperAdmin = 'super-admin',
  Coex = 'coex',
  Capataz = 'capataz',
  RoomTeam = 'room-team',
  Tablet = 'tablet',
  OperatingTeam = 'operating-team',
}

export enum Permission {
  All = 'all',
  View = 'view',
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}

export enum AccessZone {
  Dashboard = 'dashboard',
  Communications = 'communications',
  Historical = 'historical',
  WorkOrders = 'work-orders',
  NewAndDuplicateOT = 'new-and-duplicate-ot',
  Campaign = 'campaign',
  ValidateActions = 'validate-actions',
}
